import { gql } from '@apollo/client';

import { PRICING_TARIFF_FIELDS } from '@/graphql/fragments/pricing_tariffs';
import { RATE_FIELDS } from '@/graphql/fragments/rates';
import { TARIFF_CATEGORIZATION_FIELDS } from '@/components/Account/TariffLibrary/graphql';

export const LIST_GLOBAL_TARIFFS = gql`
    ${PRICING_TARIFF_FIELDS}
    ${RATE_FIELDS}
    ${TARIFF_CATEGORIZATION_FIELDS}

    query ListGlobalTariffsByClientId($where: pricing_tariffs_bool_exp!) {
        tariffs: pricing_tariffs(
            where: { _and: [$where, { tariff_type: { _eq: "ORDER" } }] }
            order_by: [{ algo_type: desc }, { created_at: desc }]
        ) {
            ...PricingTariffFields
            ...TariffCategorizationFields

            rates {
                ...RateFields
            }
        }
    }
`;
